//import axios from "axios";
import React, { useEffect, useState } from "react";
import f from "./form.module.css";
import { useDispatch, useSelector } from "react-redux";
import {
  createVideogame,
  getByGenres,
  getPlatforms,
} from "../../redux/actions";
import { Link, useHistory } from "react-router-dom";

function isNumber(n) {
  if (/^\d+$/.test(n)) {
    return true;
  }
  return false;
}

// function isString(n) {
//   if (/^\D+$/.test(n)) {
//     return true;
//   }
//   return false;
// }

function validator(datos) {
  let errores = {};
  //name
  if (!datos.name) errores.name = "Name is requiered";
  else if (datos.name.length <= 2) errores.name = "Name is too short";
  else if (datos.name.length >= 100) errores.name = "Name is too long";
  else if (typeof datos.name !== "string") errores.name = "Invalid name";
  //description
  if (!datos.description) errores.description = "Description is requiered";
  else if (datos.description.length <= 30)
    errores.description = "Description is too short";
  else if (datos.description.length >= 2200)
    errores.description = "Description is too long";
  else if (typeof datos.description !== "string")
    errores.description = "Invalid description";
  //released
  if (!datos.released) errores.released = "Date is requiered";
  //rating
  if (!datos.rating) errores.rating = "Rating is requiered";
  else if (datos.rating <= 1 || datos.rating > 6)
    errores.rating = "Rating must be between 1 and 5";
  else if (isNumber(datos.rating)) errores.rating = "Rating must be a number";
  else if (datos.rating.length > 4)
    errores.rating = "Rating must contain a maximum of two decimal places ";
  //genres
  if (!datos.genres) errores.genres = "Genre is requiered";
  //platforms
  if (!datos.platforms) errores.platforms = "Platform is requiered";
  //date
  if (typeof datos.date === Number) errores.date = "Invalid date";
  //image
  if (
    datos.image.length !== 0 &&
    !/^(https?|chrome):\/\/[^\s$.?#].[^\s]*$/.test(datos.image)
  ) {
    errores.image = "invalid URL";
  }

  return errores;
}

const CreateVideogame = () => {
  //estado local
  const [videogame, setVideogame] = useState({
    name: "",
    description: "",
    released: "",
    rating: 0,
    platforms: [],
    genres: [],
    image: "",
  });

  let history = useHistory();
  const dispatch = useDispatch();
  const allNames = useSelector((state) => state.allVideogames);
  const allGenres = useSelector((state) => state.genres);
  const allPlatforms = useSelector((state) => state.platforms);
  const [errorsForm, setErrorsForm] = useState({});
  const [botonStatus] = useState(
    Object.keys(errorsForm).length < 1 ? false : true
  );

  useEffect(() => {
    dispatch(getByGenres());
    dispatch(getPlatforms());
  }, [dispatch]);

  const handleChange = (e) => {
    setVideogame({
      ...videogame,
      [e.target.name]: e.target.value,
    });
    setErrorsForm(validator(videogame));
    console.log(e.target.value);
  };

  const handleClearGenres = () => {
    setVideogame({ ...videogame, genres: [] });
  };
  const handleClearPlatforms = () => {
    setVideogame({ ...videogame, platforms: [] });
  };

  // const handleDelete = (e) => {
  //   setVideogame({
  //     ...videogame,
  //     genres: videogame.genres.filter((genres) => genres.id !== e),
  //   });
  // };

  //multiselect-------------------

  // const [val, setVal] = useState([]);

  // const handleChangeNormalSelect = (e) => {
  //   if (
  //     !videogame.genres.includes(e.target.value) &&
  //     videogame.genres.length < 6
  //   ) {
  //     let updatedOptions = [...e.target.options]
  //       .filter((option) => option.selected)
  //       .map((x) => x.value);
  //     console.log("updatedOptions", updatedOptions);
  //     setVal(updatedOptions);

  //   }
  // };

  //------------------------------

  function handleGenres(e) {
    if (
      !videogame.genres.includes(e.target.value) &&
      videogame.genres.length < 6
    ) {
      setVideogame({
        ...videogame,
        genres: [...new Set([...videogame.genres, e.target.value])],
      });
    }
  }

  function handlePlatforms(e) {
    if (
      !videogame.platforms.includes(e.target.value) &&
      videogame.platforms.length < 5
    ) {
      setVideogame({
        ...videogame,
        platforms: [...new Set([...videogame.platforms, e.target.value])],
      });
    }
  }

  function handleSubmit(e) {
    e.preventDefault();
    let noRepeat = allNames.filter((n) => n.name === videogame.name);
    if (noRepeat.length !== 0) {
      alert(
        "There is already a game with that name, please choose another one."
      );
    } else {
      let error = Object.keys(validator(videogame)); // Object.keys(errors) --> errors = {} => devuelve un array de strings q representa todas las propiedades del objeto
      //solo habra propiedades si es que HAY ALGUN ERROR
      if (
        error.length !== 0 ||
        !videogame.genres.length ||
        !videogame.platforms.length
      ) {
        //Entonces si hay algun error, error va a ser un array con la propiedad en donde haya un error, osea que su length !== 0
        alert("Fill all the inputs");
        return;
      } else {
        dispatch(createVideogame(videogame));
        setVideogame({
          name: "",
          image: "",
          description: "",
          released: "",
          rating: "",
          genres: [],
          platforms: [],
        });
        alert("Congratulations, the game was successfully created.");
        history.push("/home");
      }
    }
  }

  return (
    <>
      <Link to="/home" className={f.btnBack}>
        {""}
      </Link>
      <div className={f.formwrapper}>
        <div className={f.formBk}>
          <h2>Create your game</h2>
          <form onSubmit={handleSubmit}>
            <div className={f.formRow}>
              <label>* Name: </label>
              <input
                type="text"
                name="name"
                value={videogame.name}
                onChange={handleChange}
                required
              />
              {errorsForm.name ? (
                <div className={`${f.alert} ${f.alertDanger}`}>
                  {errorsForm.name}
                </div>
              ) : (
                false
              )}
            </div>
            <div className={f.formRow}>
              <label>* Description: </label>
              <input
                type="textarea"
                name="description"
                value={videogame.description}
                onChange={handleChange}
                required
              />
              {errorsForm.description ? (
                <div className={`${f.alert} ${f.alertDanger}`}>
                  {errorsForm.description}
                </div>
              ) : (
                false
              )}
            </div>
            <div className={f.formRow}>
              <label>* Released: </label>
              <input
                type="date"
                name="released"
                value={videogame.released}
                onChange={handleChange}
                required
              />
              {errorsForm.released ? (
                <div className={`${f.alert} ${f.alertDanger}`}>
                  {errorsForm.released}
                </div>
              ) : (
                false
              )}
            </div>
            <div className={f.formRow}>
              <label>* Rating: </label>
              <input
                type="number"
                name="rating"
                value={videogame.rating}
                onChange={handleChange}
                required
              />
              {errorsForm.rating ? (
                <div className={`${f.alert} ${f.alertDanger}`}>
                  {errorsForm.rating}
                </div>
              ) : (
                false
              )}
            </div>

            <div className={f.formRow}>
              <label>* Genres: </label>

              {/* OPCION MULTLIPLE */}

              {/* <select
                className={f.txtSelect}
                onChange={handleChangeNormalSelect}
                size="6"
                id="genr"
                value={val}
                options={videogame.genres}
                required
                multiple
              >
                {allGenres.map((genre) => {
                  return (
                    <option key={genre.id} value={genre.name}>
                      {genre.name}
                    </option>
                  );
                })}
              </select> */}

              <select
                className={f.txtSelect}
                name="genres"
                size="6"
                value={videogame.genres}
                onChange={handleGenres}
                id="genr"
                multiple
                required
              >
                {allGenres.map((genre) => (
                  <option key={genre.id} value={genre.name}>
                    {genre.name}
                  </option>
                ))}
              </select>

              {errorsForm.genres ? (
                <div className={`${f.alert} ${f.alertDanger}`}>
                  {errorsForm.genres}
                </div>
              ) : (
                false
              )}

              <button
                className={f.btnClear}
                onClick={() => {
                  handleClearGenres();
                }}
              >
                CLEAR
              </button>
            </div>

            <div className={f.formRow}>
              <label>* Platforms: </label>
              <select
                className={f.txtSelect}
                name="platforms"
                id="platf"
                size="6"
                value={videogame.platforms}
                onChange={handlePlatforms}
                multiple
                required
              >
                {allPlatforms.map((platform) => (
                  <option key={platform} value={platform}>
                    {platform}
                  </option>
                ))}
              </select>
              {errorsForm.platforms ? (
                <div className={`${f.alert} ${f.alertDanger}`}>
                  {errorsForm.platforms}
                </div>
              ) : (
                false
              )}
              <button
                className={f.btnClear}
                onClick={() => {
                  handleClearPlatforms();
                }}
              >
                CLEAR
              </button>
            </div>
            <div className={f.formRow}>
              <label>Image: </label>
              <input
                type="text"
                name="image"
                value={videogame.image}
                onChange={handleChange}
                required
              />
              {errorsForm.image ? (
                <div className={`${f.alert} ${f.alertDanger}`}>
                  {errorsForm.image}
                </div>
              ) : (
                false
              )}
            </div>
            <br></br>
            <p>* Fields requiered</p>
            <div className={f.formRow}>
              <button
                className={f.btnSubmit}
                type="submit"
                disabled={botonStatus}
              >
                Create new
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default CreateVideogame;
